// @ts-nocheck
import ko from 'knockout';
import komapping from 'knockout.mapping';
import htmlTemplate from 'mesitis/components/users/userCard/userCardChangePwd.html?raw';
import kh from 'mesitis/utils/kendoHelper';
import bootbox from 'bootbox';
import us from 'mesitis/services/userService';
import tooltipTemplate from 'mesitis/components/users/userCard/newPasswordTooltip.html?raw';
import paths from 'paths';
import 'knockout.validation';
import 'ko-plugins/ko.validation.array';
import 'ko-plugins/ko.validation.password';
import 'kendo';
import 'kendo.data.min';
import 'kendo.tooltip.min';
import 'knockout.kendo';

function userCardChangePwdViewModel(params) {
        var self = this;
        this.errorText = ko.observableArray();
        this.infoText = ko.observable('');
        this.newPasswordTooltip = tooltipTemplate;

        this.baseDs = params.ds;
        this.fromAdmin = ko.observable(false);
        if (params.ds) self.fromAdmin(true);

        this.initModel = params.model;
        this.model = komapping.fromJS(this.initModel);

        this.model.OldPassword = ko.observable();
        this.model.NewPassword = ko.observable();
        this.model.NewPasswordConfirmation = ko.observable();

        this.model.OldPassword.extend({ required: true });
        this.model.NewPassword.extend({
            required: true,
            maxLength: 255,
            requiredPasswordValidationRules: true,
        });
        this.model.NewPasswordConfirmation.extend({
            equalsPassword: self.model.NewPassword,
        });

        this.saveNoClose = function () {
            self.errorText('');
            self.infoText('');

            if (self.errors().length !== 0) {
                self.errors.showAllMessages();
                return false;
            }

            bootbox.confirm({
                message: 'Save changes?',
                callback: function (result) {
                    if (!result) return true;

                    if (self.model.NewPasswordConfirmation() !== self.model.NewPassword()) {
                        self.clearPassword(false);
                    }

                    var success = function (resMessage) {
                        self.infoText(resMessage);
                    };

                    var dataToSend = {
                        oldPwd: self.model.OldPassword(),
                        newPwd: self.model.NewPassword(),
                    };

                    us.changePassword(dataToSend)
                        .done(function () {
                            success('Password has been changed successfully!');
                            window.location.href = paths.appPath;
                        })
                        .fail(function (error) {
                            var errorMsg = kh.unwrapError(error);
                            self.errorText(errorMsg || 'Internal server error');
                        });
                },
            });
        };

        this.reset = function (clearInfo) {
            self.clearPassword();
            self.errorText('');
            if (clearInfo === undefined || clearInfo === true) self.infoText('');
            self.errors.showAllMessages(false);
        };

        this.clearPassword = function (onlyNew) {
            if (!onlyNew) {
                self.model.OldPassword('');
            }
            self.model.NewPassword('');
            self.model.NewPasswordConfirmation('');
        };

        this.errors = ko.validation.group(this.model);
        this.canSave = ko.validatedObservable(this.model).isValid;
    }

    userCardChangePwdViewModel.prototype.dispose = function () {
        //need to dispose all ko.computed, intervals, subscriptions ..
    };
export default { viewModel: userCardChangePwdViewModel, template: htmlTemplate };
